import styled from "styled-components";

export const LabelStyled = styled.label`
    font-size: 12px;
    font-weight: bold;
    line-height: 2em;
    color: #595973;
    text-transform: uppercase;
    //margin: 8px 0 16px 0;
`;